import { render, staticRenderFns } from "./TermsService.vue?vue&type=template&id=6a883a27&"
import script from "./TermsService.vue?vue&type=script&lang=js&"
export * from "./TermsService.vue?vue&type=script&lang=js&"
import style0 from "./TermsService.vue?vue&type=style&index=0&id=6a883a27&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports